import CryptoJS from "crypto-js";

export const encrypt = (data) => {
  const encryptData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    "ctruh-encryption-key"
  ).toString();
  const encodedEncrypted = encryptData.replace(/\//g, "_");
  return encodedEncrypted;
};

export const decrypt = (data) => {
  const encodedEncrypted = data?.replace(/_/g, "/");
  const bytes = CryptoJS.AES.decrypt(encodedEncrypted, "ctruh-encryption-key");
  const decrypt = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decrypt;
};
